import React, { useState, useEffect } from 'react';
// import ReactDOM from 'react-dom';
// import { connect } from 'react-redux';
import Tools from '../../tools';
import ChargeItem from './ChargeItem';
import { Button, Container, Modal, Row, Col, Form, Card } from 'react-bootstrap';
// import { Link } from 'react-router-dom';
import API from '../../api';
import { Cookies, withCookies } from 'react-cookie';
// import Enums from '../../enums'
import { Calculator } from 'react-bootstrap-icons';
import ChargePayment from './ChargePayment';

// import { useMappedState, useDispatch } from 'redux-react-hook';

export default withCookies(function ChargeApp(props) {
    const [isFetched, setIsFetched] = useState(false);
    // const [isInit, setIsInit] = useState(false);
    const [productData, setProductData] = useState(null);
    const [oid, setOid] = useState(props.match.params.oid);
    const [orderData, setOrderData] = useState(null);
    const [step, setStep] = useState(props.match.params.step);
    const [status, setStatus] = useState(props.match.params.status);
    const [currentProduct, setCurrentProduct] = useState(null);
    const succUrl = "/charge/index";
    const E_STS = {
        "succ": "付款成功",
        "fail": "付款失敗"
    };

    useEffect(() => {
        console.log(status)
        if (null != status) {
            let tmpStsTex = (E_STS.hasOwnProperty(status)) ? E_STS[status] : "unknown";
            alert(`訂單編號${oid}：${tmpStsTex}`);
            onFinishPointPayment();
        }
    }, [props.match.params.status]);

    // useEffect(() => {
    //     console.log("updated order, product data", productData, orderData);
    //     if (productData && orderData) {
    //         let pdID = orderData.
    //         setCurrentProduct()
    //     }
    //     setIsFetched(true);
    // }, [productData, orderData]);


    useEffect(() => {
        console.log("updated", isFetched);
        if (false == isFetched) {
            API.init({ props });
            Tools.init();
            getData();
        }
        setIsFetched(true);
    }, [isFetched]);

    function getData() {
        let tmpData = {
            item_type: 0
        };
        API.GetProducts(tmpData).
            then(onDataUpdated);
    }

    function onDataUpdated(data) {
        console.log(data);
        // setIsAdmin(API.getIsAdmin());
        if (data && data.data && data.data.length > 0) {
            setProductData(data.data);
            // props.cookies.set('usr', data.display_name, { path: '/' });
        }
        // setIsInit(true);
    }

    function rednerProducts() {
        if (null == productData) return null;
        console.log(productData);
        let tmp = [];
        productData.forEach((pdData, pdIdx) => {
            tmp.push(
                <Col xs={4}>
                    <ChargeItem data={pdData} key={pdIdx} onClick={onAddChargeOrder} isPromoted={pdIdx == 0} />
                </Col>
            );
        });

        return (tmp);
    }

    function onAddChargeOrder(item_id) {
        let tmpData = {
            item_id: item_id,
            amount: 1
        };
        API.AddChargeOrder(tmpData).
            then((data) => {
                console.log(data);
                if (data) {
                    if (data.oid) {
                        console.log("購買成功, 訂單編號:" + data.oid);
                        // onFinishOrder(data.oid);
                        setOid(data.oid);

                        let tmp = [];
                        productData.forEach(val => val.item_id == item_id ? tmp.push(val) : null);
                        setCurrentProduct(tmp[0]);
                    }
                    else alert("Server error")
                } else {
                    alert("Server error");
                    console.log(data);
                }
            });
    }

    function onFinishPointPayment() {
        props.history.push(succUrl);
    }
    function onFinishOrder(oid) {
        console.log("onFinishOrder");
        props.history.push(`/charge/index/${oid}`);
    }

    function render() {
        if (oid) {
            console.log(currentProduct);
            // item_description: "(測試)進階套餐PLUS說明"
            // item_id: "IT210805175157"
            // item_name: "(測試)Premium PLUS"
            // item_type: "後台點數"
            // platform_point: 5000
            // price: 40000

            if (currentProduct) {
                let tmp = (
                    <>
                        <Col xs={12} className="mt-4 mb-4 text-center"><h3>{currentProduct.item_name}</h3></Col>
                        <Col xs={12} className="mt-2 mb-4"><label>{currentProduct.item_description}</label></Col>
                        {/* <Col xs={12}><label>性別設定:{Enums.E_GENDER_TEXT[targetData.gender]}</label></Col>
                    <Col xs={12}><label>年齡設定:{Enums.E_AGE_TEXT[targetData.age]}</label></Col>
                    <Col xs={12}><label>地區設定:{Enums.E_AREA_TEXT[targetData.region]}</label></Col>
                    <Col xs={12}><label>{order.formula_text}</label></Col> */}
                        {/* <Col xs={12}><label>-----------------------</label></Col> */}
                        {/* <Col xs={12} className="text-red"><u><strong>本次消耗：{currentProduct.platform_point}點<small>&nbsp;or&nbsp;</small>台幣{order.price}元</strong></u></Col> */}
                        <Col xs={12} className="text-red mb-4"><b>本次儲值：{currentProduct.price}元</b></Col>
                        <Col xs={8}></Col>
                    </>
                );
                return (
                    <ChargePayment oid={oid} content={tmp}
                        return_url={`${window.location.origin}/#/charge/index/${oid}/`}
                        onFinishPointPayment={onFinishPointPayment}
                        disablePoint />
                );
            }
            return "loading..."
        } else {
            return (
                <div className="container-fluid pb-4 mb-4">
                    <Row className="mb-3">
                        <Col xs={12} className="text-center">
                            <h2>儲值方案</h2>
                        </Col>
                        {/* <Col xs={6} sm={{ col: 4, offset: 8 }} className="text-right" style={{ marginTop: "-3rem", marginBottom: "2rem" }} >
                            <Button href="#/charge/calculator"><Calculator className="mr-1" />金額試算器</Button>
                        </Col> */}
                    </Row>
                    <Row className="text-center mt-3">
                        {rednerProducts()}
                    </Row>
                </div >
            );
        }
    }
    return render();
})